import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getAccountUsers } from 'services/AccountService'
import { Paging } from 'types/types'

export const useAccountUsersQuery = (paging: Paging) => {
  return useQuery({
    queryKey: reactQueryKeys.accountUsers(paging),
    queryFn: () => getAccountUsers(paging),
  })
}
